var React = require('react');

function IconCloseInline (props) {
    return React.createElement("svg",props,React.createElement("g",{"stroke":"#BDBDBD","strokeWidth":"2.25","fill":"none","fillRule":"evenodd","strokeLinecap":"round"},React.createElement("path",{"d":"M1.729 19.675L19.27 1.325M19.271 19.675L1.73 1.325"})));
}

IconCloseInline.defaultProps = {"width":"21","height":"21"};

module.exports = IconCloseInline;

IconCloseInline.default = IconCloseInline;
